<template>
  <div class="billing__container" :class="{ 'type-modal': modalClass }">
    <h2 class="billing__title">Billing plans</h2>
    <div class="billing__item-wrapper">
      <div class="billing__item-description">
        <div v-if="subscriptionInfo" class="item-description item-description--wrapper">
          <p class="item-description--title">
            Your
            {{ subscriptionInfo?.status === "trialing" ? "trialing" : "" }}
            subscription
            {{ isSubscriptionCanceled ? 'expires on ' : 'will renew on' }}
            {{ expiredDate }}
          </p>
        </div>
      </div>
    </div>
    <div class="">
      <div class="billing__plans-container">
        <div class="billing__plans-list">
          <div v-for="item of plans?.monthly" @click="selectPlan(item)">
            <BillingPlanItem :title="generatePlan(item)?.title" :price="generatePlan(item)?.price"
              :type="generatePlan(item)?.type" :active="generatePlan(item)?.active" :selected="generatePlan(item)?.selected"
              :disabled="generatePlan(item)?.selected" @click="submit(item?.prices?.[0]?.id, item)" />
          </div>
        </div>
        <!-- <p v-if="plans?.monthly.length > 0" class="billing__plans-title">
            Monthly
          </p>
          <ul class="billing__plans-list">
            <li v-for="item of plans?.monthly" class="plans-list__item">
              <button
                :disabled="!!subscriptionInfo || !chosenWidgetId"
                @click="submit(item?.prices?.[0]?.id)"
                type="submit"
                class="plans-list__item-btn"
              >
                {{ generatePlan(item) }}
              </button>
            </li>
          </ul> -->
      </div>
    </div>
    <Loader v-show="isLoading || loading" />
    <Modal :isModalOpen="showConfirmModal" @close="showConfirmModal = false">
      <div slot="body" class="modal-content modal_body">
        <h5 class="modal-title">Confirm unsubscribe</h5>
        <div class="modal-body-a">
          <p class="modal-body-delete__text" style="font-family: 'Inter', sans-serif">
            Are you sure you want to unsubscribe?
          </p>
        </div>
        <div class="modal_footer">
          <button type="button" class="navbar_btn close_btn" @click="hideConfirmModal">
            Close
          </button>
          <button type="button" class="navbar_btn btn_delete danger" @click="confirmUnsubscripe">
            Confirm
          </button>
        </div>
      </div>
    </Modal>
    <SubscriptionModal :opened="subscriptionModalOpened" :subModalData="subModalData"
      @cancel="subscriptionModalOpened = false" @click="subModalActionsHandler" />
  </div>
</template>

<script>
import Loader from "../../components/shared/Loader/Loader.vue";
import { StripeCheckout } from "@vue-stripe/vue-stripe";
import moment from "moment";
import Modal from "../../components/shared/Modal/Modal.vue";
import SubscriptionModal from "./SubscriptionModal.vue";
import BillingPlanItem from "../../components/billing/BillingPlanItem.vue";
import { DataService } from "../../config/dataService";
import store from "../../vuex/store";

export default {
  components: {
    Loader,
    StripeCheckout,
    Modal,
    SubscriptionModal,
    BillingPlanItem
  },
  props: {
    type: {
      type: String,
      default: "page",
    },
  },
  data() {
    return {
      trial_period: null,
      public_key: process.env.VUE_APP_PUBLIC_KEY,
      api: process.env.VUE_APP_API_ENDPOINT,
      plans: {
        monthly: [],
        yearly: [],
      },
      subscriptionInfo: null,
      showConfirmModal: false,
      subscriptionModalOpened: false,
      subModalData: null,
      loading: false
    };
  },
  computed: {
    isLoading() {
      return store.getters.isLoading;
    },
    modalClass() {
      return this.$props.type === "modal";
    },
    chosenWidget() {
      return store.getters?.getChosen;
    },
    chosenWidgetId() {
      return (
        store.getters?.getChosen?.id || localStorage.getItem("chosenWidget")
      );
    },
    expiredDate() {
      return this.subscriptionInfo?.end
        ? moment(new Date(this.subscriptionInfo?.end * 1000)).format(
          "YYYY-MM-DD"
        )
        : null;
    },
    isSubscriptionCanceled() {
      return this.subscriptionInfo?.cancellation_details === 'cancellation_requested'
    }
  },
  methods: {
    handleConfirmModalShow(value) {
      this.showConfirmModal = value;
    },
    hideConfirmModal() {
      this.handleConfirmModalShow(false);
    },
    confirmUnsubscripe() {
      this.hideConfirmModal()
      this.handleUnsubscribe();
    },
    async getStart() {
      try {
        this.loading = true;
        await this.checkQuery();
        await this.getSubscriptionInfo();
        store.dispatch("startLoading");
        this.loading = true;
        const { data } = await DataService.get("/stripe/prices");
        this.plans.monthly = data.filter(
          (item) => item?.prices?.[0]?.recurring?.interval === "month"
        ).sort((a, b) => {
          const priceA = a.prices[0].unit_amount;
          const priceB = b.prices[0].unit_amount;

          return priceA - priceB;
        });
        this.plans.yearly = data.filter(
          (item) => item?.prices?.[0]?.recurring?.interval === "year"
        );
        this.trial_period = data[0].trial_period;
      } finally {
        this.loading = false;
        store.dispatch("endLoading");
      }
    },
    selectPlan(item) {
      this.plans.monthly = this.plans.monthly.map(p => {
        return {
          ...p,
          clicked: p.id === item.id
        }
      })
    },
    async checkQuery() {
      const { subscription } = this.$route.query;
      if (!subscription) return;

      if (subscription === 'success') {
        this.subModalData = {
          type: 'success',
          title: 'Success!',
          subtitle: 'We are delighted to inform you that we recieved your payment',
          btn_text: 'Print receipt'
        }
        this.subscriptionModalOpened = true;
        await this.getSubscriptionInfo();
      } else if (subscription === 'failed') {
        this.subModalData = {
          type: 'failed',
          title: 'Error',
          subtitle: 'Unfortunately we have an issue with your payment. Try again later.',
          btn_text: 'Try again'
        }
        this.subscriptionModalOpened = true;
      }
    },
    subModalActionsHandler() {
      if (this.subModalData?.type === 'success') {
        const url = this.subscription?.hosted_invoice_url;

        if (url) {
          this.removeSubscriptionQuery();
          window.open(url, '_blank');
        }
      }
      this.subscriptionModalOpened = false;
    },
    removeSubscriptionQuery() {
      const currentRoute = this.$route;
      const { subscription, ...queryWithoutSubscription } = currentRoute.query;
      this.$router.replace({
        ...currentRoute,
        query: queryWithoutSubscription,
      });
    },
    async getSubscriptionInfo() {
      try {
        store.dispatch("startLoading");
        let url = `/stripe/subscription-info`;
        const { data: subscriptionData } = await DataService.get(url);

        this.subscriptionInfo = subscriptionData?.data;
      } finally {
        store.dispatch("endLoading");
      }
    },
    generatePlan(item) {
      const price = item?.prices?.[0];
      if (!price) return;

      const desc = item?.description ? item.description.toLowerCase() : '';
      const currency = price?.currency === "usd" ? "$" : price?.currency;
      return {
        price: currency + price?.unit_amount / 100,
        type: item?.description || 'starter',
        title: desc === 'scale' ? '🔥 Scale' : desc === 'growth' ? '🚀 Growth' : '👶 Starter',
        active: item?.clicked || false,
        selected: this.subscriptionInfo?.status === 'active' ? desc === this.subscriptionInfo.sub_type.toLowerCase() : false
      }
    },
    async submit(id, item) {
      try {
        const activePlan = this.subscriptionInfo?.status === 'active' ? this.subscriptionInfo.sub_type.toLowerCase() : "";
        const desc = item && item?.description ? item.description.toLowerCase() : 'starter';
        if (activePlan && (activePlan === 'scale'|| (activePlan === 'growth' && desc === 'starter'))) {
          this.$toast.warning("If you want to change the tariff, contact support support@replymonster.ai");
          return;
        }

        store.dispatch("startLoading");
        const { data } = await DataService.post(`${this.api}stripe/checkout`, {
          price: id,
          widgetId: this.chosenWidgetId,
        });

        window.location.href = data;

        if (desc === 'scale') {
          gtag('event', 'billing_plan_scale_checkout_proceed', {});
          amplitude.getInstance().logEvent('billing_plan_scale_checkout_proceed', {});
        } else if (desc === 'growth') {
          gtag('event', 'billing_plan_growth_checkout_proceed', {});
          amplitude.getInstance().logEvent('billing_plan_growth_checkout_proceed', {});
        } else {          
          gtag('event', 'billing_plan_starter_checkout_proceed', {});
          amplitude.getInstance().logEvent('billing_plan_starter_checkout_proceed', {});
        }
      } catch (error) {
        console.log({error});
        const errorText =
          error?.response?.data?.errorDescription || "Something went wrong";
        this.$toast.error(errorText);
      } finally {
        store.dispatch("endLoading");
      }
    },
    async handleUnsubscribe() {
      try {
        store.dispatch("startLoading");
        const { data } = await DataService.post(
          `${this.api}stripe/unsubscribe`,
          { id: this.subscriptionInfo?.id }
        );
        if (data?.status) {
          await new Promise((resolve) => {
            setTimeout(async () => {
              await this.getSubscriptionInfo();
              if (!this.subscriptionInfo) {
                resolve();
              }
              store.dispatch("updateChosen", { subscription: null });
            }, 3000);
          });
        }
      } catch (error) {
        const errorText =
          error?.response?.data?.errorDescription || "Something went wrong";
        this.$toast.error(errorText);
      } finally {
        store.dispatch("endLoading");
      }
    },
  },
  async mounted() {
    await this.getStart();
  },
};
</script>

<style scoped lang="scss">
.billing__container {
  padding: 35px 55px;
  font-family: "Inter", sans-serif;
  overflow: auto;

  &.type-modal {
    padding: 0;
    min-width: calc(90vw - 34px);
    min-height: 553px;
    width: 100%;

    @media (max-width: 450px) {
      min-height: 577px;
    }

    @media (min-width: 620px) {
      min-height: 451px;
      min-width: 521px;
    }
  }
}

.billing__title {
  font-size: 24px;
  line-height: 30px;
  font-weight: 600;
  color: #212b36;
  margin-bottom: 40px;
}

.billing__item-wrapper {
  font-size: 16px;
  line-height: 24px;
  color: #3e3e3e;
  font-family: "Inter", sans-serif;
  margin-bottom: 10px;
}

.billing__item-description {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: #637381;
}

.billing__icon-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 16px;
}

.item-description {
  display: flex;
  flex-wrap: wrap;

  &--title {
    font-family: inherit;
    font-size: inherit;
    margin: 0;
    padding: 0 50px 10px 0;
  }

  &--actions {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    gap: 16px;

    @media screen and (max-width: 768px) {
      justify-content: center;
    }

    &>button {
      outline: none;
      background: transparent;
      border: none;
      padding: 0;
      margin: 0;
      color: #eb5757;
      border-bottom: 1px solid #eb5757;
    }
  }
}

.billing__plans-container {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.billing__plans-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;
}

.modal_body {
  font-family: "Inter", sans-serif;
  width: 90%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  border: none;
}

.modal-content {
  background-color: transparent;
}

.modal-title {
  font-family: inherit;
  text-align: center;
}

.modal-body-a {
  padding: 32px 18px;
}

.modal_footer {
  display: flex;
  justify-content: center !important;
  flex-wrap: wrap;
  gap: 10px;
}

.btn_delete {
  border: 1px solid #e74545;
  background-color: #fff !important;
  color: #e74545 !important;
}

.btn_delete:hover {
  background: #eb5757 !important;
  color: #fff !important;
}

.close_btn {
  border: 1px solid #4764d5;
  padding: 9px 20px !important;
  font-size: 16px !important;
  color: #4764d5 !important;
}

.close_btn:hover {
  background: #4764d5 !important;
  color: #fff !important;
}

.btn_delete,
.close_btn {
  font-family: inherit;
  font-size: 16px;
  line-height: 24px;
  outline: none;
  background: transparent;
  border-radius: 6px;
  padding: 10px;
  cursor: pointer;
  transition: all 150ms linear;

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
}
</style>
